export const name = 'tourists';
